<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <template v-slot:extra>
        <!-- <a-button @click="backPage">返回</a-button> -->
      </template>
      <a-form layout="inline" class="topForm">
        <div>
          <a-form-item>
            <a-input
              v-model:value="searchForm.orderCode"
              placeholder="订单编号"
              allowClear
            />
          </a-form-item>


          <a-form-item>
            <a-input
                v-model:value="searchForm.channelCode"
                placeholder="渠道订单号"
                allowClear
            />
          </a-form-item>

<!--          <a-form-item>
            <a-input
              v-model:value="searchForm.passengerName"
              placeholder="购票人姓名"
              allowClear
            />
          </a-form-item>-->

<!--          <a-form-item>
            <a-select
              v-model:value="searchForm.checkState"
              placeholder="对账状态"
              style="width: 200px"
              @search="fetchUser"
              @change="change"
              allowClear
            >
              <a-select-option
                v-for="d in checkStateData"
                :key="d.value"
                :value="d.value"
                :label="d.label"
              >
                {{ d.label }}
              </a-select-option>
            </a-select>
          </a-form-item>-->

          <a-form-item v-show="false">
            <a-range-picker
              v-model:value="searchForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="searchAction"> 查询 </a-button>
          </a-form-item>
        </div>

        <div>
          <a-form-item>
            <a-button @click="handleDownload">导出</a-button>
          </a-form-item>

<!--      <a-form-item>
            <a-button type="primary" disabled v-if="checkState == 20"
              >已对账</a-button
            >
            <a-button type="primary" @click="handleFinish" v-else
              >确认对账</a-button
            >
          </a-form-item>-->

        </div>

      </a-form>
    </a-card>
    <!-- table -->
    <a-card
      size="small"
      title=""
      style="margin-top: 20px"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300, y: 800 }"
        :row-key="(r) => r.id"
        :loading="loading"
        class="log_content"
      >
        <template v-slot:orderNo="{ text, record }">
          <div @click="toDetail(record)">{{ record.orderCode }}</div>
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button
            type="danger"
            @click="handleDelete(record)"
            size="small"
            style="margin-right: 10px"
          >
            删除
          </a-button>
        </template>
      </a-table>
    </a-card>
    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { ref, reactive, provide, createVNode } from "vue";
import financialApi from "@axios/financial";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "insurance",
  components: {
    ExclamationCircleOutlined,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const billNo = route.query.billNo;
      const orderCode = '';
    const id = route.query.id;
    const checkState = route.query.checkState;
    const billOrderType = route.query.billOrderType;

    let activeKey = ref("0");
    let searchForm = reactive({
      billNo: "",
      orderCode: null,
      channelCode:null,
      passengerName: "",
      checkState: "",
      orderdate: [],
    });

    let searchParams = reactive({
      billNo: "",
      passengerName: "",
      checkState: "",
        orderNo: "",
    });

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const searchAction = () => {
      searchParams.billNo = searchForm.billNo;
      searchParams.passengerName = searchForm.passengerName;
      searchParams.checkState = searchForm.checkState;
      searchParams.orderCode = searchForm.orderCode;
      searchParams.channelCode = searchForm.channelCode;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    let list = ref([]);

    let loading = ref(false);

    const getList = () => {
      let params = {
        ticketType: activeKey.value == "0" ? null : activeKey.value,
        billNo: searchParams.billNo ? searchParams.billNo : billNo,
        orderCode: searchParams.orderCode ? searchParams.orderCode : null,
        channelCode: searchParams.channelCode ? searchParams.channelCode : null,
        passengerName: searchParams.passengerName
          ? searchParams.passengerName
          : null,
        checkState: searchParams.checkState ? searchParams.checkState : null,
        // checkBegin: searchParams.tktsStartTime ? searchParams.tktsStartTime : null,
        // checkEnd: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        billOrderType:billOrderType
      };

      loading.value = true;

      financialApi.getElectronicFinancialDetail(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    getList();

    const reset = () => {
      searchForm.supplierId = "";
      searchForm.orderdate = [];

      searchAction();
    };

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const handleDelete = (item) => {
      console.log(item);
    };

    let panes = ref([
      { tab: "全部", key: "0" },
/*      { tab: "出票", key: "10" },
      { tab: "改签", key: "20" },
      { tab: "退票", key: "30" },*/
    ]);
    const getDistributorCount = () => {
      let params = {
        billNo: billNo,
      };
      financialApi.getDistributorCount(params).then((res) => {
        console.log(res);
        panes.value = [
          { tab: `全部`, key: "0" },
          { tab: `出票(${res.buyType})`, key: "10" },
          { tab: `改签(${res.changesType})`, key: "20" },
          { tab: `退票(${res.returnType})`, key: "30" },
        ];
      });
    };
    getDistributorCount();

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    const backPage = () => {
      router.back();
    };

    // 导出
    const handleDownload = () => {
      let params = {
        billNo: billNo,
      };
      let fileName = "电子票渠道结算单明细-" + billNo;
      exportOut(
        params, // 导出请求参数
        "/app-finance/electronic/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 确认对帐
    const handleFinish = () => {
      Modal.confirm({
        title: "是否确认对账？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.distributorFinish(id).then((res) => {
            console.log(res);
            message.success("确认对帐");
            getList();
          });
        },
        onCancel() {},
      });
    };

    const toDetail = (row) => {
      router.push({
        name: "orderDetail",
        query: {
          code: row.orderNo,
          type: "nomalOrder",
        },
      });
    };

    return {
      checkState,
      activeKey,
      cardtabChange,
      panes,
      handleDelete,
      loading,
      list,
      pageObj,
      searchForm,
      searchAction,
      reset,
      columns: [
        {
          title: "订单号",
          dataIndex: "orderCode",
          width: 190,
          align: "center",
          fixed: "left",
        },
        {
          title: "结算单编号",
          dataIndex: "billNo",
          width: 190,
          align: "center",
          fixed: "left",
        },

        {
          title: "原单号",
          dataIndex: "originalOrderCode",
          width: 190,
          align: "center",
          fixed: "left",
        },
        {
          title: "渠道订单号",
          dataIndex: "channelCode",
          width: 120,
          align: "center",
          fixed: "left",
        },
        {
          title: "退票单号",
          dataIndex: "returnCode",
          width: 120,
          align: "center",
          className: `${"underlineStyle"}`,
          fixed: "left",
        },
        {
          title: "订单类型",
          dataIndex: "billOrderTypeStr",
          width: 120,
          align: "center",
          fixed: "left",
        },
        {
          title: "改签类型",
          dataIndex: "changeTypeStr",
          width: 120,
          align: "center",
          fixed: "left",
        },
        {
          title: "支付方式",
          dataIndex: "payTypeStr",
          width: 120,
          align: "center",
          fixed: "left",
        },
        {
          title: "销售金额",
          dataIndex: "orderAmount",
          width: 120,
          align: "center",
          slots: { customRender: "orderAmount" },
        },
        {
          title: "出票金额",
          dataIndex: "ticketAmount",
          width: 120,
          align: "center",
          slots: { customRender: "ticketAmount" },
        },
        {
          title: "结算金额",
          dataIndex: "settlementAmount",
          width: 120,
          align: "center",
          slots: { customRender: "settlementAmount" },
        },
        {
          title: "退款金额",
          dataIndex: "retrunAmount",
          width: 120,
          align: "center",
          slots: { customRender: "retrunAmount" },
        },
        {
          title: "退票手续费",
          dataIndex: "refundServiceAmount",
          width: 120,
          align: "center",
          slots: { customRender: "refundServiceAmount" },
        },
        {
          title: "订单数",
          dataIndex: "orderCount",
          width: 120,
          align: "center",
          slots: { customRender: "orderCount" },
        },
        {
            title: "票数",
            dataIndex: "ticketCount",
            width: 120,
            align: "center",
            slots: { customRender: "ticketCount" },
        },
        {
          title: "出发站",
          dataIndex: "fromStation",
          width: 100,
          align: "center",
        },
        {
          title: "到达站",
          dataIndex: "toStation",
          width: 100,
          align: "center",
        },
          {
              title: "车次号",
              dataIndex: "trainNo",
              width: 100,
              align: "center",
          },
        {
          title: "供应商",
          dataIndex: "supplierName",
          width: 200,
          align: "center",
          slots: { customRender: "supplierName" },
        },
        {
            title: "渠道商",
            dataIndex: "distributorName",
            width: 100,
            align: "center",
            slots: { customRender: "distributorName" },
        }
      ],
      checkStateData: [
        {
          label: "未对账",
          value: "10",
        },
        {
          label: "已对账",
          value: "20",
        },
        {
          label: "异常",
          value: "90",
        },
      ],
      backPage,
      handleDownload,
      handleFinish,
      toDetail,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.log_content {
  .redClass {
    color: red;
  }
}
.topForm {
  display: flex;
  justify-content: space-between;
}
</style>
